import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServices } from '../Common/CommonServices';
import { Cart, CartClient, CartDetail, User, Webinar, WebinarClient, WebinarSeat } from '../Services/WOWApi.Service';
import { CustomServiceService } from '../Services/custom-service.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
  selector: 'app-purchase-seats',
  templateUrl: './purchase-seats.component.html',
  styleUrls: ['./purchase-seats.component.css'],
  standalone: false
})
export class PurchaseSeatsComponent implements OnInit, OnDestroy {
  webinar: Webinar;
  WebinarId: number;
  loggedUser: User;
  showSpinner: boolean = false;
  selectedSeats: number[];
  cart: Cart;
  screenImg = 'assets/Images/screen-icon.svg'
  isMobileView = false;
  subscription: Subscription;
  noOfSeatsSelected = 0;
  rowCapacity = 15;
  webinarSeatsArray: any = [];
  seats: any = {};
  existingUserCart: Cart;
  cartRemainingTime = '';
  isShippingAddressFound = false;
  isBillingAddressFound = false;
  isCommunicationMethodsFound: boolean;
  isEmailVerified = false;
  maxSeatsAllowedPerUser = 0;
  seatsAlreadyInCartOrPurchasedList = 0;

  constructor(
    private webinarClient: WebinarClient,
    private router: Router,
    private cartClient: CartClient,
    private activatedRoute: ActivatedRoute,
    private commonServices: CommonServices,
    private customServices: CustomServiceService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.showSpinner = true;
    this.WebinarId = this.activatedRoute.snapshot.params.id;
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.GetWebinar();
    if (this.loggedUser !== null && this.loggedUser !== undefined) {
      this.subscription = this.commonService.userCart.subscribe(userCart => {
        this.existingUserCart = userCart;
      });
      this.subscription = this.commonService.cartExpireRemainingTime.subscribe(remainingTime => this.cartRemainingTime = remainingTime);
      this.subscription = this.commonService.billingAddress.subscribe(res => {
        this.isBillingAddressFound = (res !== null) ? true : false;
      });
      this.subscription = this.commonService.shippingAddress.subscribe(res => {
        this.isShippingAddressFound = (res !== null) ? true : false;
      });
      this.subscription = this.commonService.communicationMethods.subscribe(response => {
        if (response != null && response.phone != null && response.phone !== '' && response.phone > 0 && response.email != null && response.email !== '') {
          this.isCommunicationMethodsFound = true;
        } else {
          this.isCommunicationMethodsFound = false;
        }
      }, error => {
      this.commonServices.showMessage('error', 'Error found wile fetching communication methods', 5);
      });
      if (this.loggedUser.isEmailVerified === true) {
        this.isEmailVerified = true;
      }
    }
  }

  GetWebinar() {
    this.webinarClient.getSeats(this.WebinarId).subscribe(data => {
      this.maxSeatsAllowedPerUser = this.resolveAccountSeatLimit(data);
      this.seatsAlreadyInCartOrPurchased(this.WebinarId);
      this.webinar = data;
      this.webinar.pricePerSeat = Number(this.webinar.pricePerSeat.toFixed(2));
      this.webinar.webinarSeats = this.webinar.webinarSeats.sort((a, b) => a.seatNumber - b.seatNumber);
      this.webinar.webinarSeats.forEach(ele => {
        ele.selected = false
      });
      console.log(data);
      this.seats.available = this.webinar.webinarSeats.filter(x => x.statusId === 1);
      this.seats.Booked = this.webinar.webinarSeats.filter(x => x.statusId === 3);
      this.seats.blocked = this.webinar.webinarSeats.filter(x => x.statusId === 2);
      this.showSpinner = false;
    }, error => { this.showSpinner = false; });
  }

  presetSeatsWithRows() {
    const noOfBunchOfSeatRow = Math.floor(this.webinar.webinarSeats.length / this.rowCapacity);
    const remainderFromBunchOfSeats = this.webinar.webinarSeats.length % this.rowCapacity
    console.log(noOfBunchOfSeatRow);
    console.log(remainderFromBunchOfSeats);
    let seatArray = [];
    this.webinar.webinarSeats.map(seat => {
      seatArray.push(seat);
      if (this.webinar.webinarSeats.length > this.rowCapacity && seatArray.length === this.rowCapacity && this.webinarSeatsArray.length <= noOfBunchOfSeatRow) {
        this.webinarSeatsArray.push(seatArray);
        seatArray = [];
      }
      if (this.webinarSeatsArray.length === noOfBunchOfSeatRow && seatArray.length === remainderFromBunchOfSeats) {
        this.webinarSeatsArray.push(seatArray);
        seatArray = [];
      }
    });
    console.log(this.webinarSeatsArray);

  }

  SelectSeat(seatId: number) {
    if (this.isLoggedInUser === false) {
      this.router.navigate(['Login']);
      return;
    }
    const seat = this.webinar.webinarSeats.find(x => x.seatId == seatId);
    if (!seat) {
      return;
    }
    if (seat.selected) {
      seat.selected = false;
      this.noOfSeatsSelected = this.webinar.webinarSeats.filter(x => x.selected === true).length;
      return;
    }
    if (this.seatsAlreadyInCartOrPurchasedList + this.noOfSeatsSelected >= this.maxSeatsAllowedPerUser) {
      const limit = this.maxSeatsAllowedPerUser;
      this.commonServices.showMessage('X', `You can select a maximum of ${limit} ${limit === 1 ? 'seat' : 'seats'} for this webinar.`, 5, 'top');
      return;
    }
    seat.selected = true;
    this.noOfSeatsSelected = this.webinar.webinarSeats.filter(x => x.selected === true).length;
  }

  formatMoney(value: number | string | null | undefined): string {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
      return '$0';
    }
    return amount % 1 === 0 ? `$${amount}` : `$${amount.toFixed(2)}`;
  }

  get displayUnitPrice(): string {
    if (this.webinar?.isFreeBee || Number(this.webinar?.pricePerSeat) === 0) {
      return 'FREE';
    }
    return this.formatMoney(this.webinar?.pricePerSeat);
  }

  get displaySelectedTotal(): string {
    if (this.webinar?.isFreeBee || Number(this.webinar?.pricePerSeat) === 0) {
      return 'FREE';
    }
    return this.formatMoney(this.noOfSeatsSelected * Number(this.webinar?.pricePerSeat));
  }

  private resolveAccountSeatLimit(data: Webinar): number {
    const limit = Number(data?.maxSeatsAllowedPerUser);
    if (Number.isFinite(limit) && limit > 0) {
      return limit;
    }
    return Number(data?.numberOfSeats) || 1;
  }

  seatsAlreadyInCartOrPurchased(webinarId: number) {
    this.webinarClient.checkSeatsInWebinarForUser(webinarId).subscribe(data => {
      this.seatsAlreadyInCartOrPurchasedList = data;
    }, error => {
      this.commonServices.showMessage('Error', `Could not fetch seats already in cart or purchased, please try again`);
    });
  }

  totalAmountForSelectedSeats(noOfSeats, price) {
    const total = noOfSeats * price;
    return Number.isInteger(total) ? total : total.toFixed(2);
  }

  get isLoggedInUser() {
    const userDetails = JSON.parse(localStorage.getItem("UserInfo"));
    if (this.loggedUser == null || userDetails == null) {
      return false;
    }
    else {
      return true;
    }
  }

  getClass(seatId: number) {
    if (this.selectedSeats.filter(x => x == seatId).length > 0) {
      return 'selected';
    }
    else if (this.webinar.webinarSeats.filter(x => x.seatId == seatId)[0].statusId == 1) {
      return 'available';
    }
    else if (this.webinar.webinarSeats.filter(x => x.seatId == seatId)[0].statusId == 2) {
      return 'Booked';
    }
  }

  AddToCart() {
    if (this.isLoggedInUser === false) {
      this.router.navigate(['Login']);
      return;
    }
    if (this.isBillingAddressFound === false || this.isShippingAddressFound === false) {
      this.commonServices.showMessage('X', `Billing/ Shipping Address not found, please add your billing/ shipping address from 'My Account' to proceed.`, 5, 'top');
      return;
    }
    if (this.isCommunicationMethodsFound === false) {
      this.commonServices.showMessage('X', `Communication methods not found, please add communication methods from 'My Account' to proceed.`, 5, 'top');
      return;
    }
    if (this.isEmailVerified === false) {
      this.commonServices.showMessage('X', `Email not verified, please verify your account email address to proceed.`, 5, 'top');
      return;
    }
    if (this.webinar.webinarSeats.filter(x => x.selected == true).length == 0) {
      this.commonServices.showMessage("Error", "Please select a seat to continue");
      return;
    }
    this.showSpinner = true;
    this.cart = new Cart();
    this.cart.cartName = "Webinar";
    this.cart.userId = this.loggedUser.id;
    this.cart.cartDetails = [];

    this.webinar.webinarSeats.filter(x => x.selected == true).forEach(ele => {
      var cartD = new CartDetail();
      cartD.seatId = ele.seatId;
      cartD.webinarId = ele.webinarId;
      this.cart.cartDetails.push(cartD);
      this.showSpinner = false;
    });
    this.showSpinner = true;
    this.cartClient.cart(this.cart).subscribe(x => {
      const userCart = JSON.parse(JSON.stringify(this.existingUserCart));
      const cartDetail = JSON.parse(JSON.stringify(x.cartDetails));
      cartDetail.map(detail => {
        detail.webinar = JSON.parse(JSON.stringify(this.webinar));
        detail.webinar.room = detail.webinar.room;
        detail.createdDate = this.commonService.getUtcNow(new Date());
        userCart.cartDetails.push(detail);
      })
      this.commonService.setUserCart(userCart);
      setTimeout(() => {
        this.showSpinner = false;
        this.router.navigate(["Cart"]);
      }, 100)
    }, error => {
      this.commonServices.showMessage('Error', `Could not add items to cart, please try again`);
      this.showSpinner = false;
    });


  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
